import { Spinner as HeroSpinner } from '@heroui/react/spinner';
import { Skeleton as HeroSkeleton } from '@heroui/react/skeleton';
import { cn } from '@/utils/cn';

/** Loading spinner — HeroUI's, themed to the brand accent. */
export function Spinner({
  size = 'md',
  className,
  label = 'Loading',
}: {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  label?: string;
}) {
  return (
    <HeroSpinner
      role="status"
      aria-label={label}
      color="accent"
      size={size}
      className={className}
    />
  );
}

/** Grey placeholder block for content-shaped loading states. */
export function Skeleton({ className }: { className?: string }) {
  return <HeroSkeleton aria-hidden className={cn(className)} />;
}
